import { render, staticRenderFns } from "./BusinessPlanCard.vue?vue&type=template&id=38864763&scoped=true&"
import script from "./BusinessPlanCard.vue?vue&type=script&lang=js&"
export * from "./BusinessPlanCard.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPlanCard.vue?vue&type=style&index=0&id=38864763&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38864763",
  null
  
)

export default component.exports